import React, { useState } from 'react';

import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Paper, Typography } from '@material-ui/core';

import { tariffs } from '../../billing/timesheets/BillingTariff';

const MemberJurisdiction = ({ value, onChange }) => {

    
    const [jurisdictions, setJurisdictions] = useState(value ?? []);
    
    const handleChange = tariff => {
        // toggle whether the tariff is included
        const index = jurisdictions.findIndex(item => item === tariff);
        
        if (index >= 0) {
            const updated = jurisdictions.filter(item => item !== tariff);
            onChange({ tariffs: updated });
            setJurisdictions(updated);
        }
        else {
            const updated = [...jurisdictions, tariff];
            onChange({ tariffs: updated });
            setJurisdictions(updated);
        }
    }
    
    return (
        <Paper style={{ padding: '1rem' }}>
            <Typography variant="h6" color="initial">Which jurisdictions would you like referrals for?</Typography>
            <FormGroup row>
                <FormControlLabel control={
                    <Checkbox checked={jurisdictions.includes('tier1')} onChange={() => handleChange('tier1')} />
                }
                    label={tariffs.get('tier1').description}
                />
                <FormControlLabel control={
                    <Checkbox checked={jurisdictions.includes('defendant')} onChange={() => handleChange('defendant')} />
                }
                    label={tariffs.get('defendant').description}
                />
            </FormGroup>
        </Paper>
    );
};

export default MemberJurisdiction;